import { createSelector } from 'reselect'
import MESSAGES from 'core/data-model/constants/bi-messages'
import { getPolicyValues } from 'quick-quote/product-whole-life/benefit-illustration/selectors'
import { getSelectedDisplayProductCode } from 'quick-quote/product-selection/selectors'
import { getSumAssured } from 'quick-quote/product-common/coverage-plan/selectors'

export const getDividendRatesByProductCode = createSelector(getSelectedDisplayProductCode, (productCode) => {
  switch (productCode) {
    case 'E20F10':
      return [
        { name: MESSAGES.TERM_LIFE_BENEFITS_LOW, rate: 0 },
        { name: MESSAGES.TERM_LIFE_BENEFITS_MIDDLE, rate: 17 },
        { name: MESSAGES.TERM_LIFE_BENEFITS_HIGH, rate: 50 },
      ]
    case 'E25F15':
      return [
        { name: MESSAGES.TERM_LIFE_BENEFITS_LOW, rate: 0 },
        { name: MESSAGES.TERM_LIFE_BENEFITS_MIDDLE, rate: 14 },
        { name: MESSAGES.TERM_LIFE_BENEFITS_HIGH, rate: 55 },
      ]
    case 'E25F25':
      return [
        { name: MESSAGES.TERM_LIFE_BENEFITS_LOW, rate: 0 },
        { name: MESSAGES.TERM_LIFE_BENEFITS_MIDDLE, rate: 25 },
        { name: MESSAGES.TERM_LIFE_BENEFITS_HIGH, rate: 60 },
      ]
    default:
      return [
        { name: MESSAGES.TERM_LIFE_BENEFITS_LOW, rate: 0 },
        { name: MESSAGES.TERM_LIFE_BENEFITS_MIDDLE, rate: 13 },
        { name: MESSAGES.TERM_LIFE_BENEFITS_HIGH, rate: 40 },
      ]
  }
})

export const getInvestmentBenefitParams = createSelector(
  getPolicyValues,
  getDividendRatesByProductCode,
  getSumAssured,
  (policyValue, dividendRates, sumAssured) => ({ policyValue, dividendRates, sumAssured })
)

export const getInvestmentBenefit = (state) => state.benefitIllustration.investmentBenefit
